import SendReportEmailModalView from './SendReportEmailModalView';
const meta = {
    title: 'Features/Reports/SendReportEmailModal',
    component: SendReportEmailModalView,
    parameters: { layout: 'fullscreen' },
    args: {
        isOpen: true,
        onClose: () => undefined,
        onSubmit: () => undefined
    }
};
export default meta;
const reportLink = '<a href="https://d1ubp9hvv96vde.cloudfront.net/tenant5/report.pdf">2026-10-01-Main Plant-Annual-Complete</a>';
const draft = {
    sendToEmail: 'brent@customer.com, facilities@customer.com',
    subject: '2026-10-01-Main Plant-Annual-Complete – Main Plant',
    body: 'Hello,\n\nYour report for Main Plant is ready. You can download it here:\n\n' +
        `${reportLink}\n\n` +
        'If you are not the appropriate recipient of this report, please forward it to the proper person.',
    pdfUrl: 'https://d1ubp9hvv96vde.cloudfront.net/tenant5/report.pdf'
};
export const Default = { args: { draft } };
export const LargePdf = {
    args: { draft: Object.assign(Object.assign({}, draft), { pdfAutoPreview: false, pdfSizeLabel: '286 MB' }) }
};
export const NoPdfYet = { args: { draft: Object.assign(Object.assign({}, draft), { pdfUrl: null }) } };
export const NoReportContacts = { args: { draft: Object.assign(Object.assign({}, draft), { sendToEmail: null }) } };
export const Loading = { args: { draft: null, loading: true } };
export const LoadFailed = { args: { draft: null, loadFailed: true } };
export const Sending = { args: { draft, sending: true } };
